import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetFooterStaticLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {useCustomerIsVip} from '@aboutyou/user';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useEntityIdentifier} from '../../Header/hooks/useEntityIdentifier';

export const useFooterStaticData = () => {
  const isVip = useCustomerIsVip();
  const identifier = useEntityIdentifier();
  const {initialTargetGroup} = useSelectedTargetGroup();

  return useGrpcRequest(
    NavigationService_GetFooterStaticLazy,
    {
      isVip,
      sessionTargetGroup: initialTargetGroup ?? null,
      identifier: identifier ?? null,
    },
    {
      // The `identifier` & `sessionTargetGroup` is only used for SEO and does not need to ever update on the client. This change makes sure we always use the same cache instance in all places and never redo the request after it was made once.
      transformCacheKey(config) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {identifier, sessionTargetGroup, ...params} = config.params;
        return {
          ...config,
          params,
        };
      },
      nonEssential: true,
    },
  );
};
